import { sortBy } from 'lodash';
import { Flow, FlowRule, RuleValidationResponse } from '../model/flow.types';
import { FlowRuleService, RuleValidateOptions } from './service.types';

class FlowRuleServiceImpl implements FlowRuleService {
  validateFlow(
    flow: Flow,
    rules: FlowRule[],
    options?: RuleValidateOptions
  ): RuleValidationResponse[] {
    const errors: RuleValidationResponse[] = [];
    const earlyReturn = options?.earlyReturn ?? false;

    for (const rule of rules) {
      const result = rule.execute(flow);
      if (result) {
        errors.push(result);
      }
      if (earlyReturn) {
        break;
      }
    }

    return sortBy(errors, ['endIndex']);
  }
}

export { FlowRuleServiceImpl };
